export default {"src":"/_next/static/media/apk-qr-primexbt-com.7afdf16a.svg","height":225,"width":225,"blurWidth":0,"blurHeight":0};